import React from "react";
import "./DashboardCard.scss";
import DownTrend from "../../assets/icons/DownTrend";
import UpTrend from "../../assets/icons/UpTrend";

const DashboardCard = ({ card }) => {
  return (
    <div
      className="dashboard-card"
      style={{ background: card.bg }}
    >
      <div className="dashboard-card_container">
        <div className="dashboard-card_heading">
          <h4>{card?.heading}</h4>
        </div>
        <div className="dashboard-card_section">
          <div className="dashboard-card_section_left">
            <h3>{card?.value}</h3>
          </div>
          <div className="dashboard-card_section_right">
          <h6>{card?.percentage}%</h6>
          {card?.percentage > 0 ? <UpTrend /> : <DownTrend />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardCard;
